import React from 'react';
import Header from './Header';
import './MainLayout.css';

interface MainLayoutProps {
    children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
    return (
        <div className="main-layout">
            <Header />
            <main className="main-content">
                {children}
            </main>
            {/* <footer className="footer">
                <div className="container">
                    <p>&copy; 2026 PDF Editor.</p>
                </div>
            </footer> */}
        </div>
    );
};

export default MainLayout;
